import React, { useEffect, useState } from 'react';
//COMPONENTES
import DialogLoadingMessage from 'components/LoadingMessage/index'
import Form from 'components/Form/FormTwoColumns';
import MostrarPDFModal from 'components/PdfModal'
import {useStyles} from './style';
import { functions } from "constants/index";
import ApiServices from 'services/ApiServices';
import {Description} from '@material-ui/icons/';
import { Container, Grid } from '@material-ui/core';
import { showMessagePersonalizedPosition } from 'services/SweetAlert';

export default function  FiltrosParaGenerarConstanciaDeActa (props) {
    const classes = useStyles(),
    [abrirMostrarPDFModal, setAbrirMostrarPDFModal] = useState({open: false, base64:''});
    const [loadingStateCity, setLoadingStateCity] = useState({loading:false, title:''});

    const [elements,setElements] = React.useState({
        datosDelUsuario:{
            idelement: "datosDelUsuario",title:'Datos del usuario', position:"left", value: "", isError:true, elementType:'customTitle', validators: ['requireds'],
        },
            nombreDelOperador: {
                idelement: "nombreDelOperador",  value: props.data.general.usuarioAsignado.nombre, label: "Nombre", pattern:"", validators: ['requireds'], finalRequiredLength: 0,
                errorMessages:[''], isError:false, elementType:'textField', disabled: 'true', size: '550px',
            },        
            usuarioDelOperador: {
                idelement: "usuarioDelOperador",  value: props.data.general.usuarioAsignado.codUsuario, label: "Usuario", pattern:"", validators: ['requireds'], finalRequiredLength: 0,
                errorMessages:[''], isError:false, elementType:'textField', disabled: 'true', size: '550px',
            },           
            descripcionUsuario: {
                idelement: "descripcionUsuario",  value: props.data.general.usuarioAsignado.descripcion, label: "Descripción", pattern:"", validators: ['requireds'], finalRequiredLength: 0,
                errorMessages:[''], isError:false, elementType:'textField', disabled: 'true', size: '750px',
            },           
        titlePlace:{
            idelement: "titlePlace",title:'Departamento y Municipio', position:"left", value: "", isError:true, elementType:'customTitle', validators: ['requireds'],
        },            
            departamento: {
                idelement: "departamento", value: props.data?.depto || null, label: "Departamento *", pattern:"", validators: ['requireds'], disabled: true,
                errorMessages:['Seleccione el Departamento'], isError:false, elementType:'autocompleteV2', list: [], variant:'outlined'
            },
            municipio: {
                idelement: "municipio", value: props.data.muni || null, label: "Municipio *", pattern:"", validators: ['requireds'], disabled: true,
                errorMessages:['Seleccione el Municipio'], isError:false, elementType:'autocompleteV2', list: [], variant:'outlined'
            },
        titleObservacion:{
            idelement: "titleObservacion",title:'Ingrese Observación', position:"left", value: "", isError:true, elementType:'customTitle', validators: ['requireds'],
        },    
            observacion: {
                idelement: "observacion",  value:'', label: "Observación", pattern:"^[\\w1-9 _ÑñwáéíóúÁÉÍÓÚ:.,!¡\"#$%&/()=¿?'@*-]{0,150}$",
                validators: ['requireds'], errorMessages:['Máximo 150 carácteres'], isError:false, elementType:'textArea', showInputControl: true,
            },            
        titleFirma:{
            idelement: "titleFirma",title:'Ingrese Firma Electrónica', position:"left", value: "", isError:true, elementType:'customTitle', validators: ['requireds'],
        },            
            password: { 
                idelement: "password",  value:'', label: 'Ingrese contraseña *', pattern:"^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[$@#$!¡:.;{}+=^~|%*¿?&/-])[A-Za-z\\d$@#$!¡:.;{}+=^~|%*¿?&/-]\\S{6,20}$", 
                validators: ['required'], errorMessages:['Contraseña requerida'], isError:false, elementType:'password', variant:'outlined'
            },                
    });

    const CerrarMostrarPDFModal = () => {
        setAbrirMostrarPDFModal({open: false, base64:''})
        props.actualizarTabla()
        props.closeModal()
    }
    const FuncionGenerarInforme = async () => {
        setAbrirMostrarPDFModal({open: false, base64: ''});
        setLoadingStateCity({loading: true, title:'Generando informe de cierre de padrón ...'})                
        let saveData = {
            departamento: elements.departamento.value?.id,
            municipio: elements.municipio.value?.id,
            observacion: elements.observacion.value,
            password: elements.password.value,
        };
        try {
            let response = await ApiServices.generarInformeCierre.informe(saveData)
            if(response.error!==null){
                showMessagePersonalizedPosition('error','¡Advertencia!', response.error,'center')
            }
            else{
                showMessagePersonalizedPosition('success','¡BIEN!', 'Informe de cierre de padrón generado correctamente.','center')
                let getBase64 = response.data.split('data:application/pdf;base64,')
                setAbrirMostrarPDFModal({open: true, base64: getBase64[1]});
            }
        } catch (exception) {
            showMessagePersonalizedPosition('error', '¡Advertencia! ',"Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.",'center')
        }  
        setLoadingStateCity({loading: false, title:''})
    };

    const [buttonList,setButtonList]= React.useState({
        "constancia":{"label":"Generar Informe","icon": <Description />,"callback":FuncionGenerarInforme,"loading":loadingStateCity.loading, disabled:loadingStateCity.loading, "size":"medium", "background":"linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)", "border":"0px", "borderRadius":"3", "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px",},   
    });

    const DescargarPDF = () => {functions.downloadPDFFromStringBase64(abrirMostrarPDFModal.base64, ('Informe de '+elements.departamento.value?.name+' - '+elements.municipio.value?.name+'.pdf'));}

    return (
        <div>
            <DialogLoadingMessage open={loadingStateCity.loading} title={loadingStateCity.title}/>
            <br/>
            <Container maxWidth="lg">        
                <Grid container style={{textAlign: 'center'}}>
                    <div className={classes.colorComponente} style={{width: '100%', position: 'relative', overflow: 'auto', border: '1px solid  #cccccc', borderRadius: '20px', marginBottom:10,}} >
                        <Grid item xs={12} container direction="row" justifyContent="center" alignItems="center">
                            <Form   elements= {elements} buttonList={buttonList}/>
                        </Grid>
                        <div className={classes.lineaDegradadaBottom}></div>
                    </div>
                </Grid>
                {
                    (abrirMostrarPDFModal.open) && (
                        <MostrarPDFModal open={abrirMostrarPDFModal.open} handleClose={CerrarMostrarPDFModal} 
                            title={'Informe de: '+elements.departamento.value?.name+' - '+elements.municipio.value?.name}
                            base64={abrirMostrarPDFModal.base64} DescargarPDF={DescargarPDF}
                        />
                    )
                }
            </Container>
        </div>
    );   
}